// janus-engine/ability/damage-type-pick.ts — a user_choice_1_damage_type PICK on a cast (damage_type_roll.php ~L476), shared by janus.ts (which
// admits the variable) and damage-type-roll.ts (which applies it). Its own module so janus.ts need not import the damage pipeline.
import { type JanusCtx, type Row, record, scalar, upper } from './context.js';
import { nextSpellPlan } from '../sanguine/next-spell.js';

/** A DAMAGE-TYPE PICK on this cast: either variable naming one of the ability's OWN damage_type entries (the user_choice_1_damage_type
 *  select offers exactly those). null otherwise — a type the ability does not author would be a Sanguine retype
 *  (sanguine_cast_damage_type_choice), not modelled. (Ported 2026-10-13 — Elemental Grasp was refused 'janus:variable-mode'.) */
export function damageTypePickOf(ctx: JanusCtx, ability: Row, variable1: unknown, variable2?: unknown): string | null {
  const retype = nextSpellPlan(ability)?.damageType;
  if (retype) return retype;
  const pick = upper(scalar(variable1));
  if (!/^[0-9A-F]{8}(?:-[0-9A-F]{4}){3}-[0-9A-F]{12}$/.test(pick))
    return variable2 == null ? null : damageTypePickOf(ctx, ability, variable2);
  const own = ctx.read.entries(ability, 'damage_type').map((entry) =>
    upper(typeof entry === 'string' ? entry : record(record(entry)?.items)?.item_id ?? record(entry)?.item_id));
  return own.includes(pick) ? pick : null;
}
